import { z } from 'zod';
import { FocusArea } from 'libs/end-to-end/src/focus-area';

export const DynamicPipelineAnalysisPhase = z
  .object({
    focusArea: FocusArea,
    metric: z.string(),
    positiveTranslation: z.string().optional(),
    customPositiveTranslation: z.string().optional(),
    negativeTranslation: z.string().optional(),
    customNegativeTranslation: z.string().optional(),
    negativeResultHasNextPhase: z.boolean().optional(),
  })
  .describe('DynamicPipelineAnalysisPhase');

export type DynamicPipelineAnalysisPhase = z.infer<
  typeof DynamicPipelineAnalysisPhase
>;

export const DynamicPipelineAnalysisConfiguration = z
  .object({
    name: z.string(),
    firstPhaseName: z.string(),
    customFirstPhaseName: z.string().optional(),
    phases: z.array(DynamicPipelineAnalysisPhase),
    filterSetName: z.string().optional(),
  })
  .describe('DynamicPipelineAnalysisConfiguration');

export type DynamicPipelineAnalysisConfiguration = z.infer<
  typeof DynamicPipelineAnalysisConfiguration
>;

// Employee lifecycle configuration to be used for older revisions that do not
// pipeline analysis configurations created.
export const defaultEmployeeLifecycleConfiguration: DynamicPipelineAnalysisConfiguration =
  {
    name: 'overviewNavigationEmployeeLifecycle',
    firstPhaseName: 'pipelineAnalysisSectionTitleApplicantPool',
    phases: [
      {
        focusArea: 'Hiring',
        metric: 'hire',
        positiveTranslation: 'pipelineAnalysisSectionTitleHired',
        negativeTranslation: 'pipelineAnalysisSectionTitleNotHired',
        negativeResultHasNextPhase: false,
      },
      {
        focusArea: 'Performance',
        metric: 'perf_review',
        positiveTranslation: 'pipelineAnalysisSectionTitleHighPerformers',
        negativeTranslation: 'pipelineAnalysisSectionTitleLowPerformers',
        negativeResultHasNextPhase: true,
      },
      {
        focusArea: 'Promotion',
        metric: 'promotion',
        positiveTranslation: 'pipelineAnalysisSectionTitlePromoted',
        negativeTranslation: 'pipelineAnalysisSectionTitleNotPromoted',
        negativeResultHasNextPhase: true,
      },
      {
        focusArea: 'Attrition',
        metric: 'attrition',
        positiveTranslation: 'pipelineAnalysisSectionTitleStayed',
        negativeTranslation: 'pipelineAnalysisSectionTitleLeft',
        negativeResultHasNextPhase: true,
      },
    ],
  };
